/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import 'quasar/dist/quasar.ie.polyfills.js'






// We load Quasar stylesheet file
import 'quasar/dist/quasar.css'




import 'src/css/app.less'

import 'src/css/mobile.less'


import Vue from 'vue'
import createApp from './app.js'















const publicPath = ``


async function start () {
  const { app, store, router } = await createApp()

  

  

  

    

    

    
      new Vue(app)
    

    

    

  

}

start()
